// Parol talablari: backend (RegisterRequest, parolni almashtirish) bilan bir xil
export const PASSWORD_RULES = [
  { key: "pw_rule_length", test: (v) => v.length >= 8 },
  { key: "pw_rule_upper", test: (v) => /[A-Z]/.test(v) },
  { key: "pw_rule_lower", test: (v) => /[a-z]/.test(v) },
  { key: "pw_rule_digit", test: (v) => /[0-9]/.test(v) },
  { key: "pw_rule_symbol", test: (v) => /[^A-Za-z0-9\s]/.test(v) },
];

export const STRENGTH = [
  { key: "pw_strength_weak", color: "#d64545" },
  { key: "pw_strength_weak", color: "#d64545" },
  { key: "pw_strength_fair", color: "#e0a030" },
  { key: "pw_strength_good", color: "#2f9e8f" },
  { key: "pw_strength_strong", color: "#0f766e" },
];

// 1 zaif, 2 o'rtacha, 3 yaxshi (barcha talablar), 4 kuchli (barcha talablar + 12 belgidan uzun)
export const passwordScore = (v) => {
  if (!v) return 0;
  const passed = PASSWORD_RULES.filter((r) => r.test(v)).length;
  if (passed === PASSWORD_RULES.length) return v.length >= 12 ? 4 : 3;
  return passed >= 3 ? 2 : 1;
};

// Kriptografik tasodifiy parol: har bir turdan kamida bitta belgi
export const generatePassword = (length = 14) => {
  const sets = [
    "ABCDEFGHJKLMNPQRSTUVWXYZ",
    "abcdefghijkmnopqrstuvwxyz",
    "23456789",
    "!@#$%^&*-_=+?",
  ];
  const all = sets.join("");
  const rand = (n) => {
    const a = new Uint32Array(1);
    window.crypto.getRandomValues(a);
    return a[0] % n;
  };
  const chars = sets.map((s) => s[rand(s.length)]);
  while (chars.length < length) chars.push(all[rand(all.length)]);
  for (let i = chars.length - 1; i > 0; i--) {
    const j = rand(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join("");
};


export const isStrongPassword = (v) => PASSWORD_RULES.every((r) => r.test(v || "")) && !/\s/.test(v || "");
